import request from '@/config/axios'
export const topicPage = (params: any) => request.get({ url: '/short-video/topic/page', params })
export const topicCreate = (data: any) => request.post({ url: '/short-video/topic/create', data })
export const topicUpdate = (data: any) => request.put({ url: '/short-video/topic/update', data })
export const topicDelete = (id: number) =>
  request.delete({ url: '/short-video/topic/delete', params: { id } })
export const creatorPage = (params: any) =>
  request.get({ url: '/short-video/creator/page', params })
export const creatorUpdate = (data: any) =>
  request.put({ url: '/short-video/creator/update', data })
export const creatorAudit = (data: any) => request.post({ url: '/short-video/creator/audit', data })
export const creatorLevelPage = (params: any) =>
  request.get({ url: '/short-video/creator-level/page', params })
export const creatorLevelCreate = (data: any) =>
  request.post({ url: '/short-video/creator-level/create', data })
export const creatorLevelUpdate = (data: any) =>
  request.put({ url: '/short-video/creator-level/update', data })
export const creatorLevelDelete = (id: number) =>
  request.delete({ url: '/short-video/creator-level/delete', params: { id } })
export const creatorLevelListEnabled = () =>
  request.get({ url: '/short-video/creator-level/list-enabled' })
export const sensitiveWordPage = (params: any) =>
  request.get({ url: '/short-video/sensitive-word/page', params })
export const sensitiveWordCreate = (data: any) =>
  request.post({ url: '/short-video/sensitive-word/create', data })
export const sensitiveWordUpdate = (data: any) =>
  request.put({ url: '/short-video/sensitive-word/update', data })
export const sensitiveWordDelete = (id: number) =>
  request.delete({ url: '/short-video/sensitive-word/delete', params: { id } })
export const auditPage = (params: any) => request.get({ url: '/short-video/audit/page', params })
export const auditHandle = (data: any) => request.post({ url: '/short-video/audit/handle', data })
export const marketingPage = (params: any) =>
  request.get({ url: '/short-video/marketing/page', params })
export const marketingCreate = (data: any) =>
  request.post({ url: '/short-video/marketing/create', data })
export const marketingUpdate = (data: any) =>
  request.put({ url: '/short-video/marketing/update', data })
export const marketingDelete = (id: number) =>
  request.delete({ url: '/short-video/marketing/delete', params: { id } })
export const commentPage = (params: any) =>
  request.get({ url: '/short-video/moderation/comment-page', params })
export const commentHandle = (data: any) =>
  request.put({ url: '/short-video/moderation/comment-handle', data })
export const commentDelete = (id: number) =>
  request.delete({ url: '/short-video/moderation/comment-delete', params: { id } })
export const reportPage = (params: any) =>
  request.get({ url: '/short-video/moderation/report-page', params })
export const reportHandle = (data: any) =>
  request.put({ url: '/short-video/moderation/report-handle', data })
export const relationPage = (params: any) =>
  request.get({ url: '/short-video/relation/page', params })
export const relationCreate = (data: any) =>
  request.post({ url: '/short-video/relation/create', data })
export const relationUpdate = (data: any) =>
  request.put({ url: '/short-video/relation/update', data })
export const relationDelete = (id: number) =>
  request.delete({ url: '/short-video/relation/delete', params: { id } })
export const statisticsOverview = () => request.get({ url: '/short-video/statistics/overview' })
export const incomePage = (params: any) => request.get({ url: '/short-video/income/page', params })
export const incomeGrant = (data: any) => request.post({ url: '/short-video/income/grant', data })
